// removed by extract-text-webpack-plugin
module.exports = {"icon":"desktopFooter__icon--4BAc9","enterEmailInput":"desktopFooter__enterEmailInput--11Fq7","footerBlurbText":"desktopFooter__footerBlurbText--3Fvjm","signUpButton":"desktopFooter__signUpButton--10FIv","footerLeftLabel":"desktopFooter__footerLeftLabel--5QRRc","footerLeftLabelText":"desktopFooter__footerLeftLabelText--39ZF4","footerSegment":"desktopFooter__footerSegment--7UDo8"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Footer/DesktopFooter/desktopFooter.css
// module id = UiKl
// module chunks = 1